jQuery(document).ready(function($) {
	var isotope_container = $('.case-studies-list #casestudies_grid');
	isotope_container.imagesLoaded(function(){
		isotope_container.isotope({
			itemSelector: '.grid-item',
			percentPosition: true,
			masonry: {
				columnWidth: '.grid-sizer'
			}
		})
	});

	$('.case-study-gallery .slick').slick({
		dots: true,
		nav: false,
		arrows: true,
		adaptiveHeight: false,
		infinite: true,
		fade: true,
		prevArrow: '<span class="slick-prev hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-left"></span></span>',
		nextArrow: '<span class="slick-next hidden-xs hidden-sm hidden-md"><span class="glyphicon glyphicon-menu-right"></span></span>',
	});
	$('.case-study-gallery .slick .slick-dots > li').each(function(){
		$(this).find('button').text( 0 + $(this).find('button').text() );
	});

	$('.case-study-related .slick').slick({
		dots: true,
		nav: false,
		arrows: false,
		adaptiveHeight: false,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 3,
		centerMode: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					dots: false,
					centerMode: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
});
